module.exports = __webpack_public_path__ + "media/images/favicon-b17ff0a86292b821980c59cc04744315.png";